import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { CandidateBasicDetails, SchedulerCandidate } from 'src/app/shared/models/schedulerAssociate';
import { AssociateService } from 'src/app/modules/schedulerpersona/services/associate.service';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';

@Component({
  selector: 'candidate-list',
  templateUrl: './candidate-list.component.html',
  styleUrls: ['./candidate-list.component.scss'],
  standalone: false,
})
export class CandidateListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() selectFirstCandidate: boolean;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('dataSourceToChild') public dataSource: SchedulerCandidate[];
  @Output() profileData = new EventEmitter();

  itemSize = 70;

  selectedCandidate: SchedulerCandidate;
  correspondenceFlag: boolean;
  rejectionFlag: boolean;
  scheduleFlag: boolean;
  candidateBasicDetails: CandidateBasicDetails;
  data = {
    // Required
    type: 'Candidate-List component', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '3', //Required.  Unique page id
    itype: '', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };

  constructor(
    private associateService: AssociateService,
    private _telemetryServices: TelemetryServices,
  ) {}

  ngOnInit() {
    console.log('candy', this.dataSource);
    // telemtry  API CALL and, send data
    this.data.subtype = 'Candidate-List';
    this.data.itype = 'AUTO';
    this.data.stageto = 'displyed upon clicking values in schedule table';
    if (this.data) {
      this._telemetryServices.telemetryImpression(this.data);
    }

    // console.log(this.selectFirstCandidate);
  }

  displayCandidate(selectedCandidate) {
    // console.log('displayCandidate',selectedCandidate);

    this.selectedCandidate = selectedCandidate;
    //emitting to parent
    this.profileData.emit(this.selectedCandidate);

    // updating selected candidate application ID
    if (this.selectedCandidate) {
      //in future for multiple candidates
      const candidateAppId = [];
      candidateAppId.push(this.selectedCandidate.applicationId);
      if (candidateAppId && candidateAppId.length > 0) {
        this.associateService.setSelectedCandidate(candidateAppId);
      }
    }

    this.data.subtype = 'on button click';
    this.data.itype = 'button click';
    this.data.stageto = 'display candidate upon clicking the button';
    if (this.data) {
      // this._telemetryServices.telemetryInteract(this.data);
    }
  }
  getSkills(candidate) {
    if (typeof candidate['candidateSkills'] === 'string') {
      if (candidate['candidateSkills'].length <= 20) {
        return candidate['candidateSkills'];
      } else {
        return candidate['candidateSkills'].substring(0, 20) + '..';
      }
    } else {
      const skills = candidate['candidateSkills'][0]['primarySkill'];
      if (skills.length == 1) {
        return skills;
      } else if (skills.length > 1) {
        return skills.toString();
      } else {
        return '';
      }
    }
  }

  ngOnChanges() {
    console.log('called here');
    if (this.selectFirstCandidate) {
      if (this.dataSource.length > 0) {
        this.displayCandidate(this.dataSource[0]);
      }
    }
  }
  ngOnDestroy() {
    // telemtry end call

    this.data.subtype = 'Candidate-List cleanup stage/end of page';

    this.data.itype = 'AUTO';
    this.data.stageto = 'destroy component,initial page';
    if (this.data) {
      // this._telemetryServices.telemetryEnd(this.data);
    }
  }
}
